import React, { useState } from "react";
import { Formik } from "formik";
import { INITIAL_VALUES, VALIDATION_SCHEMA } from "./form-data";
import { handler } from "./SubmissionHandler";
import ContactInformation from "./ContactInformation";
import BuildingInformation from "./BuildingInformation";

import {
    PageWrapper,
    Submit,
    ErrorWrapper,
    StyledForm,
    GlobalStyle,
    ConfirmationWrapper,
} from "./styles";

export default function ContactForm() {
    const [showErrors, setShowErrors] = useState(false);
    const [formDataSubmitted, setFormDataSubmitted] = useState(false);
    const submitFormData = handler;
    return (
        <>
            <GlobalStyle />
            <PageWrapper>
                <Formik
                    initialValues={INITIAL_VALUES}
                    validationSchema={VALIDATION_SCHEMA}
                    onSubmit={(values, actions) => {
                        submitFormData(values);

                        const timeOut = setTimeout(() => {
                            actions.setSubmitting(false);
                            setFormDataSubmitted(true);
                            clearTimeout(timeOut);
                        }, 1000);
                    }}
                >
                    {({
                        errors,
                        touched,
                        values,
                        handleSubmit,
                        isSubmitting,
                        isValid,
                        setFieldValue,
                    }) => {
                        if (formDataSubmitted) {
                            return (
                                <ConfirmationWrapper>
                                    <h1>Thank you</h1>
                                    <p>
                                        Your submission has been received and is
                                        being processed by our team
                                    </p>
                                </ConfirmationWrapper>
                            );
                        } else
                            return (
                                <>
                                    <StyledForm
                                        name="contact"
                                        method="POST"
                                        autoComplete={"on"}
                                        onSubmit={handleSubmit}
                                        submitted={toString(formDataSubmitted)}
                                    >
                                        <h4>Contact Us</h4>
                                        <p className="intro-section">
                                            If you have questions about our
                                            products, or would like a company
                                            representative to contact you,
                                            please provide us with your contact
                                            information in the form below.
                                        </p>
                                        <ContactInformation
                                            errors={errors}
                                            touched={touched}
                                            values={values}
                                            isValid
                                        />
                                        <BuildingInformation
                                            errors={errors}
                                            touched={touched}
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            isValid
                                        />
                                        <Submit
                                            type="submit"
                                            disabled={
                                                isSubmitting ||
                                                !touched.firstName
                                            }
                                            onClick={(values) => {
                                                if (isValid) {
                                                    handleSubmit(values);
                                                } else {
                                                    setShowErrors(true);
                                                }
                                            }}
                                        >
                                            {isSubmitting
                                                ? `Submiting...`
                                                : `Submit`}
                                        </Submit>
                                    </StyledForm>
                                    <ErrorWrapper
                                        aria-label="errors"
                                        showErrors={showErrors}
                                    >
                                        {Object.keys(errors).map((el) => {
                                            return <p key={el}>{errors[el]}</p>;
                                        })}
                                    </ErrorWrapper>
                                </>
                            );
                    }}
                </Formik>
            </PageWrapper>
        </>
    );
}
